// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CuratedList_CuratedImage__B6hZD {
  aspect-ratio: 120/180;
  border: 5px solid #ffffff;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 20%;
  flex: 0 0 auto;
  animation: CuratedList_scroll__AiQ8w 10s linear infinite;
}
@media (max-width: 600px) {
  .CuratedList_CuratedImage__B6hZD {
    width: 30%;
  }
}
@media (max-width: 400px) {
  .CuratedList_CuratedImage__B6hZD {
    width: 40%;
  }
}
.CuratedList_CuratedImage__B6hZD img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}
@keyframes CuratedList_scroll__AiQ8w {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.CuratedList_CuratedList__mSfo5 {
  width: 100%;
  height: 100%;
  background: #faf4f2;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: var(--border-radius-large);
  padding: 24px;
  overflow: hidden;
  position: relative;
}
.CuratedList_CuratedList__mSfo5 .CuratedList_CuratedListText__ok0pv h2 {
  font-weight: bold;
  font-style: Bold;
  font-size: 22px;
  font-family: var(--font-bodoni);
}
.CuratedList_CuratedList__mSfo5 .CuratedList_CuratedListImage__xdgiF {
  display: flex;
  justify-content: start;
  align-items: stretch;
  gap: 7px;
  overflow: hidden;
  margin-top: 12px;
}
.CuratedList_CuratedList__mSfo5 .CuratedList_CuratedListButton__qUO1G {
  position: absolute;
  right: 12px;
  bottom: 12px;
  padding: 0 0 8px 0;
}
@media (max-width: 600px) {
  .CuratedList_CuratedList__mSfo5 .CuratedList_CuratedListButton__qUO1G {
    padding: 14px 24px 0 24px;
  }
}
.CuratedList_CuratedList__mSfo5 .CuratedList_CuratedListButton__qUO1G button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 15px;
  gap: 8px;
  width: fit-content;
  height: 44px;
  background: #ffffff;
  opacity: 0.8;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 999px;
  font: var(--body-font-two);
  color: #1d1b20;
}
@media (max-width: 600px) {
  .CuratedList_CuratedList__mSfo5 .CuratedList_CuratedListButton__qUO1G button {
    position: unset;
  }
}
.CuratedList_CuratedList__mSfo5 .CuratedList_CuratedListButton__qUO1G button img {
  width: 20px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/CuratedList.module.scss"],"names":[],"mappings":"AAAA;EACC,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,wDAAA;AACD;AACC;EAZD;IAaE,UAAA;EAEA;AACF;AAAC;EAhBD;IAiBE,UAAA;EAGA;AACF;AADC;EACC,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAGF;AAAC;EACC;IACC,wBAAA;EAED;EACA;IACC,4BAAA;EACD;AACF;;AAGA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,yCAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAAD;AAGE;EACC,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AADH;AAKC;EACC,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;AAHF;AAMC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAJF;AAME;EAND;IAOE,yBAAA;EAHD;AACF;AAKE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,4CAAA;EACA,oBAAA;EAMA,0BAAA;EACA,cAAA;AARH;AAGG;EAdD;IAeE,eAAA;EAAF;AACF;AAKG;EACC,WAAA;EACA,YAAA;AAHJ","sourcesContent":[".CuratedImage {\r\n\taspect-ratio: 120/180;\r\n\tborder: 5px solid #ffffff;\r\n\tborder-radius: 20px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\toverflow: hidden;\r\n\twidth: 20%;\r\n\tflex: 0 0 auto;\r\n\tanimation: scroll 10s linear infinite;\r\n\r\n\t@media (max-width: 600px) {\r\n\t\twidth: 30%;\r\n\t}\r\n\r\n\t@media (max-width: 400px) {\r\n\t\twidth: 40%;\r\n\t}\r\n\r\n\timg {\r\n\t\tobject-fit: cover;\r\n\t\tobject-position: center;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t}\r\n\r\n\t@keyframes scroll {\r\n\t\t0% {\r\n\t\t\ttransform: translateX(0);\r\n\t\t}\r\n\r\n\t\t100% {\r\n\t\t\ttransform: translateX(-100%);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.CuratedList {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground: #faf4f2;\r\n\tbox-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\r\n\tborder-radius: var(--border-radius-large);\r\n\tpadding: 24px;\r\n\toverflow: hidden;\r\n\tposition: relative;\r\n\r\n\t.CuratedListText {\r\n\t\th2 {\r\n\t\t\tfont-weight: bold;\r\n\t\t\tfont-style: Bold;\r\n\t\t\tfont-size: 22px;\r\n\t\t\tfont-family: var(--font-bodoni);\r\n\t\t}\r\n\t}\r\n\r\n\t.CuratedListImage {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: start;\r\n\t\talign-items: stretch;\r\n\t\tgap: 7px;\r\n\t\toverflow: hidden;\r\n\t\tmargin-top: 12px;\r\n\t}\r\n\r\n\t.CuratedListButton {\r\n\t\tposition: absolute;\r\n\t\tright: 12px;\r\n\t\tbottom: 12px;\r\n\t\tpadding: 0 0 8px 0;\r\n\r\n\t\t@media (max-width: 600px) {\r\n\t\t\tpadding: 14px 24px 0 24px;\r\n\t\t}\r\n\r\n\t\tbutton {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: row;\r\n\t\t\tjustify-content: center;\r\n\t\t\talign-items: center;\r\n\t\t\tpadding: 12px 15px;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: fit-content;\r\n\t\t\theight: 44px;\r\n\t\t\tbackground: #ffffff;\r\n\t\t\topacity: 0.8;\r\n\t\t\tbox-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\r\n\t\t\tborder-radius: 999px;\r\n\r\n\t\t\t@media (max-width: 600px) {\r\n\t\t\t\tposition: unset;\r\n\t\t\t}\r\n\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tcolor: #1d1b20;\r\n\r\n\t\t\timg {\r\n\t\t\t\twidth: 20px;\r\n\t\t\t\theight: 20px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CuratedImage": `CuratedList_CuratedImage__B6hZD`,
	"scroll": `CuratedList_scroll__AiQ8w`,
	"CuratedList": `CuratedList_CuratedList__mSfo5`,
	"CuratedListText": `CuratedList_CuratedListText__ok0pv`,
	"CuratedListImage": `CuratedList_CuratedListImage__xdgiF`,
	"CuratedListButton": `CuratedList_CuratedListButton__qUO1G`
};
export default ___CSS_LOADER_EXPORT___;
